/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Template/SaveAction",
  disabled
  
}) {
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath,
  disabled
  
})
let noteTemplatesTabNoteTemplateIdValueData = fromData.useDataValue({ viewPath,
context: 'note_templates_tab',
path: 'note_template.id',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
 disabled={disabled}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={noteTemplatesTabNoteTemplateIdValueData ? "Save changes" : "Add new template"}
 data="note_templates_tab.note_template.id"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}